module.exports = __webpack_public_path__ + "static/media/national-2-compressed-web-medium.4f593fdc.woff2";